module.exports = __webpack_public_path__ + "static/sec7-sm-bg-afe9d03f2a8212740e1f54d9eab87ff7.jpg";